const loadItems = (button) => {
  const sectionEl = button.closest('.shopify-section');
  const scope = sectionEl || document;
  const grid = scope.querySelector('.load-more-grid');
  const nextUrlInput = scope.querySelector('input[data-next-url]');
  const totalPagesInput = scope.querySelector('input[data-total-pages]');
  const currentPageInput = scope.querySelector('input[data-current-page]');

  if (!grid || !nextUrlInput || !totalPagesInput || !currentPageInput) return;

  const totalPages = parseInt(totalPagesInput.value);
  const currentPage = parseInt(currentPageInput.value) + 1;
  const nextUrl = nextUrlInput.value.replace(/page=[0-9]+/,'page='+currentPage);
  currentPageInput.value = currentPage;

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      const responseDoc = new DOMParser().parseFromString(responseHTML, 'text/html');
      let sourceGrid = null;
      if (sectionEl && sectionEl.id) {
        const responseSection = responseDoc.getElementById(sectionEl.id);
        if (responseSection) sourceGrid = responseSection.querySelector('.load-more-grid');
      }
      if (!sourceGrid) sourceGrid = responseDoc.querySelector('.load-more-grid');
      if (sourceGrid) grid.insertAdjacentHTML('beforeend', sourceGrid.innerHTML);
      colorSwatches();
    },
    complete: function() {
      if (currentPage <= totalPages) {
        if (currentPage != totalPages && button.classList.contains('js-infinite-scroll')) {
          observeSpinner(button);
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    }
  })
}

const observeSpinner = (spinner) => {
  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(entry.target);
        }
      })
    }
  );

  sectionObserver.observe(spinner);
}

const checkVisibility = () => {
  document.querySelectorAll('.js-infinite-scroll').forEach(spinner => {
    observeSpinner(spinner);
  })
}

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
